import { Box, Typography } from '@mui/material';
import { ArrowForwardIosRounded } from '@mui/icons-material';
import { Image, Link, LinkProps } from 'components/lib';
import React, { ReactElement } from 'react';
import { Surface } from '..';

export interface ClickCardProps extends Omit<LinkProps, 'children' | 'as'> {
  logo?: string;
  title: string;
  subtitle?: string;
}

export const ClickCard = ({
  logo,
  title,
  subtitle,
  ...linkProps
}: ClickCardProps): ReactElement => {
  return (
    <Link {...linkProps}>
      <Surface
        sx={{
          color: theme => theme.palette.primary.main,
          cursor: 'pointer',
        }}
        noInnerPadding
      >
        <Box display="flex" alignItems="center">
          <Box width={50} height={50}>
            {logo && (
              <Image
                src={logo}
                alt={title}
                width={50}
                height={50}
                style={{
                  borderRadius: 25,
                  border: '1px solid #D9D9D9',
                }}
              />
            )}
          </Box>
          <Box ml={10}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.875em' }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography sx={{ fontSize: '0.75em' }}>{subtitle}</Typography>
            )}
          </Box>
          <Box ml="auto" lineHeight={0}>
            <ArrowForwardIosRounded style={{ fontSize: '1em' }} />
          </Box>
        </Box>
      </Surface>
    </Link>
  );
};
